import OrderPIIStore from 'modules/order/stores/OrderPIIStore';
class PiiDataValidator {
	constructor(rootStore) {
		this.orderPiiStore = new OrderPIIStore(rootStore);
	}

	checkIfUncodedPiiDataExists(order) {
		return (
			(order.buyerEmail != null && order.buyerEmail != '') ||
			(order.shippingCity != null && order.shippingCity != '') ||
			(order.shippingZipCode != null && order.shippingZipCode != '') ||
			order.shippingCoreCountryId != null ||
			order.shippingCoreCountryStateId != null
		);
	}
}

export default PiiDataValidator;



// WEBPACK FOOTER //
// ./src/core/utils/PiiDataValidator.js